import React, { Component } from "react";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import { states } from "../../../reducers/queriesStates";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withUnits } from "../../../shared/containers/containerUnits";

import styles from "./cmsUnitChangePanel.module.scss";
import Scrollbars from "react-custom-scrollbars-2";

class CmsSharedUnitTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      selectCompanyId: null,
    };
  }

  componentDidMount() {
    if (this.props.data.permissions.includes(11002)) {
      const { onGetCompanies, ownershipAreasDataState } = this.props;

      if (ownershipAreasDataState !== states.READY) {
        onGetCompanies({ count: -1 });
      } else {
        this.setCompanies();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.permissions.includes(11002)) {
      const { ownershipAreasDataState } = this.props;

      if (ownershipAreasDataState === states.READY && prevProps.ownershipAreasDataState === states.REQUEST) {
        this.setCompanies();
      }
    }
  }

  setCompanies() {
    const { ownershipAreas, company } = this.props;

    let companies = [];

    ownershipAreas.ownershipAreas.forEach((area) => {
      const areaCompanies = area.companies.filter((item) => {
        return company.id !== item.id;
      });

      if (areaCompanies.length > 0) {
        companies = companies.concat(areaCompanies);
      }
    });

    companies = companies.sort((a, b) => {
      const nameA = a.title.toUpperCase();
      const nameB = b.title.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });

    this.setState({ companies });
  }

  onSelectComany(e) {
    this.setState({ selectCompanyId: e.target.value });
  }

  onUnitShared() {
    const { selectCompanyId, companies } = this.state;
    const { currentUnit, onUnitShared } = this.props;

    const company = companies.filter((x) => {
      return x.id === selectCompanyId;
    })[0];

    onUnitShared(currentUnit.id, company);
  }

  onUnitUnShared(company) {
    const { currentUnit, onUnitUnShared } = this.props;

    onUnitUnShared(currentUnit.id, company);
  }

  render() {
    const { companies, selectCompanyId } = this.state;
    const { currentUnit, changeUnitSharedDataState } = this.props;

    if (!this.props.data.permissions.includes(11002)) {
      return null;
    }

    return (
      <div>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 250, display: "inline-block" }}>
          <div style={{ display: "flex" }}>
            <Select style={{ minWidth: "700px" }} onChange={this.onSelectComany.bind(this)}>
              <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
                {"- - - "}
              </MenuItem>
              {companies
                .filter((item) => {
                  return !currentUnit.companies.some((x) => {
                    return x.id === item.id;
                  });
                })
                .map((area) => {
                  return (
                    <MenuItem key={area.id} value={area.id} className={styles.MuiButtonBase_resolve}>
                      {area.title}
                    </MenuItem>
                  );
                })}
            </Select>
            <div style={{ paddingLeft: "30px" }}>
              {selectCompanyId !== null ? (
                <div>
                  {changeUnitSharedDataState === states.REQUEST ? (
                    <Preloader />
                  ) : (
                    <ButtonPrimary handleClick={this.onUnitShared.bind(this)} title="Добавить к компании" />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </FormControl>

        <div className={styles.cmsUnitPanelCompanies}>
          <h3>Компании с предоставленным доступом к транспортному средству:</h3>

          <Scrollbars ref="scrollbar" style={{ height: "480px" }} autoHide={false}>
            {currentUnit.companies.map((x) => {
              return (
                <div key={x.id} className={styles.cmsUnitCompanyItem}>
                  <div className={styles.cmsUnitCompanyItemRemove}>
                    <TooltipWrapper title={`Удалить из компании ${x.title}`} position="right">
                      <div onClick={this.onUnitUnShared.bind(this, x)}>
                        <DeleteOutlineIcon fontSize="large" />
                      </div>
                    </TooltipWrapper>
                  </div>
                  <div>
                    <span>{x.title}</span>
                  </div>
                </div>
              );
            })}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withUnits(withCompanies(withAuth(CmsSharedUnitTools)));
